export default "__VITE_ASSET__f91190a7__"